/* global globals, translations */
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

// import FlashMessageStore from '../../legacy/flux/stores/FlashMessageStore';

const { ActionTypes } = Constants;

module.exports = {
  saveSettings(form) {
    if (!form) {
      AppDispatcher.dispatch({
        type: ActionTypes.VIP_SAVE_SETTINGS_ERROR,
      });
    }

    fetch(`${get(globals, 'apiWebroot', '/')}vip/save_settings`, {
      method: 'post',
      credentials: 'include',
      body: new FormData(form),
    }).then((resp) => resp.json()).then((data) => {
      if (typeof data.status !== 'undefined' && data.status === 'ok') {
        AppDispatcher.dispatch({
          type: ActionTypes.VIP_SAVE_SETTINGS_SUCCESS,
        });

        /* if (!form.parentNode && !form.parentNode.parentNode) {
          return;
        }

        const options = {
          style: {
            top: form.parentNode.offsetTop,
            left: form.parentNode.parentNode.offsetLeft,
            width: form.parentNode.parentNode.clientWidth,
          }
        };

        FlashMessageStore.removeAll();
        FlashMessageStore.add(String(Date.now()), 'success', get(translations, 'txt: Uzstādījumi saglabāti', ''), options);
        FlashMessageStore.emitChange(); */
      } else if (typeof data.msg !== 'undefined') {
        AppDispatcher.dispatch({
          type: ActionTypes.VIP_SAVE_SETTINGS_ERROR,
          msg: data.msg,
        });
      } else if (typeof data.errors !== 'undefined') {
        AppDispatcher.dispatch({
          type: ActionTypes.VIP_SAVE_SETTINGS_ERROR,
          errors: data.errors,
        });
      } else {
        AppDispatcher.dispatch({
          type: ActionTypes.VIP_SAVE_SETTINGS_ERROR,
        });
      }
    }).catch((data) => {
      console.log(data);
      AppDispatcher.dispatch({
        type: ActionTypes.VIP_SAVE_SETTINGS_ERROR,
      });
    });
  },
};
